export default __webpack_public_path__ + "ef1149e9b94764b69215effe5e246a3a.woff2";